// extracted by mini-css-extract-plugin
export default {"services":"Services_services__4q1mW","scroll":"Services_scroll__ZZ-FX"};